export default {
    columns: {
        image: 'Image',
        title: 'Title',
        updatedAt: 'Date',
        innovationFields: 'Innovation-fields',
        innovationProjects: 'Innovation-projects',
        managers: 'Managers'
    }
}
